import {
  useAvaturnHelperType,
  useUserProfileHelperType,
} from '@features/avaturn/pages/Avaturn/interfaces';
import { LastWebsocketJsonMessageType } from '@interfaces/webSocketConnectionInfo';

import { env } from 'env';

const { REACT_APP_CLIENT_ENV } = env;

const getUseAvaturnHelper = () => {
  let useAvaturnHelper: useAvaturnHelperType;

  switch (REACT_APP_CLIENT_ENV) {
    case 'EK':
      useAvaturnHelper =
        require('@clients/ek/features/avaturn/hooks/useAvaturnHelper').default;
      break;
    default:
      useAvaturnHelper =
        require('@features/avaturn/hooks/useAvaturnHelper').default;
  }

  return useAvaturnHelper;
};

const getUseUserProfileHelper = () => {
  let useUserProfileHelper: useUserProfileHelperType;

  switch (REACT_APP_CLIENT_ENV) {
    case 'EK':
      useUserProfileHelper =
        require('@clients/ek/features/avaturn/hooks/useUserProfileHelper').default;
      break;
    default:
      useUserProfileHelper =
        require('@features/avaturn/hooks/useUserProfileHelper').default;
  }

  return useUserProfileHelper;
};

const getHandleWebsocketMsgHelper = () => {
  let useClientHandleWebsocketMsg: (
    lastJsonMessage: LastWebsocketJsonMessageType,
  ) => void;

  switch (REACT_APP_CLIENT_ENV) {
    case 'EK':
      useClientHandleWebsocketMsg =
        require('@clients/ek/hooks/useHandleWebsocketMsg').default;
      break;
    default:
      useClientHandleWebsocketMsg =
        require('@core/dashboard/hooks/useHandleWebsocketMsg').default;
  }

  return useClientHandleWebsocketMsg;
};

export const useAvaturnHelper = getUseAvaturnHelper();
export const useUserProfileHelper = getUseUserProfileHelper();

export const useClientHandleWebsocketMsg = getHandleWebsocketMsgHelper();
